import LastLoginCheckRequestModelBase from '../_generated/modelBases/last-login-check-request-model-base';

export default class LastLoginCheckRequestModel extends LastLoginCheckRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
